import Porter from '@alife/mscc-porter';
import cookies from '@alife/mscc-cookie';
import pageSchema from './pageSchema';
import {isAndroid, generateUUID} from '../common/utils';

const cna = cookies.getCna();
const pageid = window.dmtrack_pageid;
const language = cookies.getLanguage();
const isNewUser = cookies.getIsNewUser();
const aliBeaconId = cookies.core.get('aliBeaconId');
const username = /^x_lid=([^&]+)/.test(cookies.core.get('xman_us_t')) ? RegExp.$1 : '';

function listenDownloadApp () {
  const bodyDom = document.body;
  bodyDom.addEventListener('click', function (e) {
    let count = 0; // 防止形成死循环
    let currentDom = e.target;
    while(currentDom !== bodyDom && count < 50) {
      count++;
      if (currentDom.className.indexOf('new-download-app') < 0) {
        currentDom = currentDom.parentNode;
        continue;
      }
      currentDom.dataset && handlerDownloadApp(currentDom.dataset)
      break;
    }
  })
}

function handlerDownloadApp ({ck, page = 'home', cancel = false, linkParams = '', schemaParams = ''}) {
  aplusDot(ck, cancel ? 'cancel' : 'download');
  if (cancel) return;
  let _pageSchema = handlerPageSchema(page);
  let schemaLink = `enalibaba://${_pageSchema}`;
  if (schemaParams) {
    schemaLink = `enalibaba://${_pageSchema}${_pageSchema.indexOf('?') < 0 ? '?' : ''}${schemaParams}`;
  }
  const wakeLink = `${schemaLink}${schemaLink.indexOf('?') < 0 ? '?' : ''}${/\?$/.test(schemaLink) ? '' : '&'}cross=msiteJs&ck=${ck}&cna=${cna}&pageid=${pageid}`;
  const dynamicLink = `https://app.alibaba.com/dynamiclink?schema=${encodeURIComponent(schemaLink)}&bts=new&ck=${ck}${linkParams && `&${linkParams}`}&cna=${cna}&pageid=${pageid}&language=${language}&isNewUser=${isNewUser}&username=${username}&aliBeaconId=${aliBeaconId}`;
  const _uuid = generateUUID();
  if (isAndroid) {
    // 尝试直接唤醒APP
    window.location.href = wakeLink;
    setTimeout(function () {
      // 打点
      Porter.get(`${dynamicLink}&click_id=${_uuid}`);
      // 跳转到应用市场
      window.location.href = `market://details?id=com.alibaba.intl.android.apps.poseidon&referrer=click_id%3D${_uuid}`;
    }, 100)
  } else {
    window.location.href = `${dynamicLink}&click_id=${_uuid}`;
  }
}

function handlerPageSchema(page) {
  const mobileType = isAndroid ? 'andriod' : 'ios';
  let commonSchema = pageSchema[page] ? pageSchema[page][mobileType] : pageSchema['home'][mobileType];
  // 差异化处理
  const pathname = window.location.pathname;
  if (page === 'detail') {
    let matchResult = pathname.match(/\/product\/(\d+)\//) || pathname.match(/\/p-detail\/.+-(\d+)/);
    commonSchema += matchResult[1] + '&';
  }
  return commonSchema
}

function aplusDot (ck, action) {
  if (!window.goldlog) {
    throwLog('goldlog不存在。无法发送打点');
  }
  window.goldlog && window.goldlog.record('/sc.mobile.download-app','CLK',`ck=${ck}&action=${action}&spm=${goldlog.spm_ab.length ? goldlog.spm_ab.join('.') : ''}&pageid=${window.dmtrack_pageid}`,'GET')
}

function throwLog (msg) {
  if (!msg) return;
  console.log(`全局引流JS：${msg}`);
}

export default listenDownloadApp


// WEBPACK FOOTER //
// ./src/listen-download-app/index.js